import { Box, Button, LinearProgress, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { commons } from '../../commons';
import { formToObj, validateFormData } from '../../lib/validator';
import { customStyles } from "../../styles/tableStyle"
import { useNavigate } from 'react-router-dom';
import { registerForm } from '../../schema/formSchema/signup';
import FormGenerator from '../../lib/FormGenerator';
import { toast } from 'react-toastify';

function RegisterForm(props) {
  const [loginData, setLoginData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    loadForm();
  }, []);

  const loadForm = async () => {
    let loginSchemaData = [...registerForm];
    if (props.role != undefined && props.role === false) {
      let index = loginSchemaData.findIndex(item => item.key === "role")
      if (index > -1) loginSchemaData.splice(index, 1)
    }
    setLoginData(loginSchemaData);
  };

  const registerUser = async (event) => {
    event.preventDefault();
    let loginContent = [...loginData];
    let validFormData = await validateFormData(loginContent);
    setLoginData(validFormData)
    let result = validFormData.find(item => {
      if (item.error.length) return item;
    });

    let passwordData = validFormData.find(item => item.key === "password");
    let confirmPasswordData = validFormData.findIndex(item => item.key === "confirmPassword")
    if (passwordData.value != validFormData[confirmPasswordData].value) {
      validFormData[confirmPasswordData].error = "Invalid password"
      setLoginData(validFormData)
      result = validFormData.find(item => {
        if (item.error.length) return item;
      });
    }
    if (!result) {
      setLoading(true)
      let params = await formToObj(validFormData);
      params.op = "createUser"
      delete params.confirmPassword
      commons.getAPIRes(params, "POST", "register").then(userRes => {
        setLoading(false)
        if (userRes.status) {

          if (props.closeDialog) props.closeDialog()
          if (props.reloadPage) props.reloadPage()

          toast.success("User registered successfully");
          redirectToLogin()
        }
        else {
          toast.error("Could not Register user");
        }
      });
    }
  };

  const handleChange = e => {
    let formDataInput = [...loginData];
    formDataInput.find(item => {
      if (item.key === e.target.name) {
        item.value = item.type === "number" ? parseInt(e.target.value) : e.target.value;
      }
    });
    setLoginData(formDataInput)
  };

  const redirectToLogin = () => {
    navigate("/login");
  };

  return (
    <Box sx={{ 
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      {loading && <LinearProgress sx={{ width: '100%'}} />}
      {props.title ? <Typography variant='h5' style={{ marginBottom: 20 ,fontWeight: 'bold' }}>{props.title}</Typography> : false}
      <FormGenerator
        formList={loginData}
        editMode={true}
        onChange={handleChange}
      />

      <div style={{ 
        display: 'flex', 
        flexDirection: 'row', 
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 20,
        width: '100%'
      }}>
        {props.closeDialog ?
          <Button
            color="secondary"
            variant="contained"
            fullWidth
            onClick={props.closeDialog}
            style={{ ...customStyles.submitBtn, width: 'fit-content', marginRight: 10 }}
          >
            Cancel
          </Button>
          : false}
        <Button
          type="Submit"
          color="secondary"
          variant="contained"
          fullWidth
          onClick={registerUser}
          disabled={loading}
          style={{ ...customStyles.submitBtn, width: 'fit-content' }}
        >
          {props.closeDialog ? "Submit" : "Register"}
        </Button>
      </div>

{props.role != undefined && props.role === false? 

      <div style={{
        display: 'flex', 
        flexDirection: 'row',
        justifyContent: 'center', 
        alignItems: 'center',
        marginTop: 20,
        width: '100%'
      }}>
        <Typography variant='caption'>Already have an account ? &nbsp;</Typography>
        <Typography 
          style={{ ...customStyles.hyperlink, cursor: 'pointer' }}
          variant='subtitle1'
          onClick={redirectToLogin}
        >
          Login here
        </Typography>
      </div>: null}
    </Box>
  );
}

export default RegisterForm;
